import React, { useState, useEffect } from "react";
import { dateFormator, keyToTitle, mapTableRows } from "../../../utils";
import { DocumentPreview } from "../../../components/Onboarding/document/DocumentPreview";
import {
  Button,
  FormFieldSet,
  Modal,
  PageTitle,
  showToast,
  TableAdv,
  Backdrop,
  LogoLoader,
  ProgressBar,
  StatusTags,
  NoData,
} from "../../../components";
import headerLogo from "../../../assets/images/HeaderLogoNew.svg";
import navHeaderLogoIcon from "../../../assets/sideBar/navHeaderLogoIcon.svg";
import { useLocation } from "react-router-dom";
import { useCallback } from "react";
import {
  fetchOneOnboarding,
  updateOnboarding,
} from "../../../redux/slices/onboarding/onboardingApi";
import { usePagination } from "../../../hooks";
import { onboardingDocumentCategory } from "../../../assets/data/enumData";
import {
  getPresignedUrl,
  uploadFiles,
} from "../../../redux/slices/universal/fileUploadApi";
import { fieldsToDroppedFieldsMapper } from "../../../utils/wf/onboarding.helpers";

const ApplicantFill = () => {
  const location = useLocation();
  const onboardingInfo = location?.state?.onboardingInfo || null;
  const [documents, setDocuments] = useState([]);
  const [onboardingData, setOnboardingData] = useState({});
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { page, limit, setPage, setLimit, handleLimitChange } =
    usePagination(25);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Close sidebar on small screens by default
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchOnboardingInfo();
  }, [onboardingInfo]);

  const fetchOnboardingInfo = useCallback(async () => {
    try {
      setLoading(true);
      const refConfig = {
        1: {
          ref: "Employee",
          incl: "firstName middleName lastName gender employmentType uiid jobTitle email dob ssn.number mobile joinDate location",
        },
        2: {
          ref: "Entity",
          incl: "generalInfo.locations contacts businessName federalId",
        },
        3: {
          ref: "Entity",
          incl: "generalInfo.locations contacts businessName federalId",
        },
      };
      if (
        !onboardingInfo?.entity?.meta?.id ||
        !onboardingInfo?.entity?.entity?.type
      ) {
        throw new Error("Onboarding ID or entity type not found");
      }
      const entityType = onboardingInfo?.entity?.entity?.type - 1;
      const res = await fetchOneOnboarding({
        uiid: onboardingInfo?.entity?.meta?.id,
        // ref: `${refConfig[location?.state.entityType]} Checklist PdfTemplate`,
        ref: `${refConfig[entityType]?.ref} Checklist PdfTemplateWithInitator OnboardingDocInitiator`,
        incl: [
          refConfig[entityType]?.incl || "",
          "",
          "",
          "firstName lastName uiid",
        ],
      });
      const onboardingDb = res?.data?.data || {};
      const currentUserId = onboardingDb?.entity?.id?.uiid;
      const alldocuments = onboardingDb?.checklists?.flatMap(
        (a) => a.documents,
      );
      setOnboardingData(onboardingDb);
      setCurrentUserId(currentUserId);
      setDocuments(alldocuments);
    } catch (error) {
      setLoading(false);
      console.error("Error in fetchOnboardingInfo:", error);
    } finally {
      setLoading(false);
    }
  }, [onboardingInfo]);

  // useEffect(() => {
  //   if (file && Array.isArray(file) && file.length > 0) {
  //     handleMultipleFilesUpload(file);
  //   }
  // }, [file]);

  // const handleMultipleFilesUpload = (files) => {
  //   try {
  //     const newFiles = files.map((uploadedFile) => ({
  //       id: Date.now().toString() + Math.random(),
  //       name: uploadedFile?.name || "Unnamed File",
  //       size: formatFileSize(uploadedFile?.size || 0),
  //       type: uploadedFile?.type || getFileType(uploadedFile?.name || ""),
  //       uploadDate: new Date().toLocaleDateString(),
  //       uploadTime: new Date().toLocaleTimeString(),
  //       file: uploadedFile,
  //     }));

  //     setUploadedFiles((prev) => [...prev, ...newFiles]);
  //     showToast(
  //       `${files.length} file${
  //         files.length > 1 ? "s" : ""
  //       } uploaded successfully`,
  //       "success"
  //     );
  //   } catch (error) {
  //     console.error("Error uploading files:", error);
  //     showToast("Failed to upload files", "error");
  //   } finally {
  //     setFile(null);
  //   }
  // };

  // const formatFileSize = (bytes) => {
  //   if (!bytes || bytes === 0) return "0 Bytes";
  //   const k = 1024;
  //   const sizes = ["Bytes", "KB", "MB", "GB"];
  //   const i = Math.floor(Math.log(bytes) / Math.log(k));
  //   return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  // };

  // const getFileType = (filename) => {
  //   if (!filename || typeof filename !== "string") {
  //     return "application/octet-stream";
  //   }

  //   if (!filename.includes(".")) {
  //     return "application/octet-stream";
  //   }

  //   try {
  //     const extension = filename.split(".").pop().toLowerCase();
  //     const typeMap = {
  //       pdf: "application/pdf",
  //       doc: "application/msword",
  //       docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //       jpg: "image/jpeg",
  //       jpeg: "image/jpeg",
  //       png: "image/png",
  //       gif: "image/gif",
  //       txt: "text/plain",
  //       xls: "application/vnd.ms-excel",
  //       xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     };
  //     return typeMap[extension] || "application/octet-stream";
  //   } catch (error) {
  //     console.error("Error in getFileType:", error);
  //     return "application/octet-stream";
  //   }
  // };

  // const getFileIcon = (type) => {
  //   if (type.includes("pdf")) return "picture_as_pdf";
  //   if (type.includes("image")) return "image";
  //   if (type.includes("word") || type.includes("document"))
  //     return "description";
  //   if (type.includes("spreadsheet") || type.includes("excel"))
  //     return "table_chart";
  //   return "insert_drive_file";
  // };

  // const handleDeleteFile = (fileId) => {
  //   setUploadedFiles((prev) => prev.filter((f) => f.id !== fileId));
  //   showToast("File removed successfully", "success");
  // };

  // Calculate progress for a document
  const calculateProgress = (doc) => {
    const allFields = Object.values(doc.droppedFields || {}).flat();
    const applicantFields = allFields.filter((f) => f.role === "applicant");
    const filledFields = applicantFields.filter((f) => {
      if (typeof f.value === "object" && f.value?.type === "userFilled") {
        return f.value.data?.[currentUserId]?.value;
      }
      return f.value && String(f.value).trim() !== "";
    });
    return {
      filled: filledFields.length,
      total: applicantFields.length,
      percentage:
        applicantFields.length > 0
          ? Math.round((filledFields.length / applicantFields.length) * 100)
          : 0,
    };
  };

  const columns = [
    {
      key: "documentName",
      label: "Document Details",
      columnMenu: false,
      render: (row) => (
        <div className="flex items-center gap-3">
          <span className="material-symbols-outlined  text-2xl">
            description
          </span>
          <div>
            <div className="font-medium text-gray-900">{row?.id?.name}</div>
            <div className="text-sm text-gray-500 capitalize">
              {
                onboardingDocumentCategory?.find(
                  (a) => a.value === row?.id?.type,
                )?.label
              }
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "createdDate",
      label: "Created Date",
      columnMenu: false,
      render: (row) => (
        <div className="text-sm">{dateFormator(row?.initiatedOn)}</div>
      ),
    },
    {
      key: "dueDate",
      label: "Due Date",
      columnMenu: false,
      render: (row) => (
        <div className="text-sm">{dateFormator(row?.dueDate)}</div>
      ),
    },
    {
      key: "progress",
      label: "Progress",
      columnMenu: false,
      render: (row) => {
        const mappedFields = fieldsToDroppedFieldsMapper(
          row?.fields || [],
          row?.id?.fields || {},
        );
        const allFields =
          Object.entries(mappedFields)?.flatMap(([k, v]) => v) || [];
        const applicantFilledFields =
          allFields
            ?.filter((field) => field?.role === "applicant" && field?.value)
            ?.filter(Boolean) || [];
        const applicantAllFields =
          allFields
            ?.filter((field) => field?.role === "applicant")
            ?.filter(Boolean) || [];
        const progress = {
          filled: applicantFilledFields?.length || 0,
          total: applicantAllFields?.length || 0,
          percentage: Math.round(
            ((applicantFilledFields?.length || 0) /
              (applicantAllFields?.length || 1)) *
              100,
          ),
        };
        return (
          <div className="flex items-center gap-3">
            <ProgressBar
              value={progress.filled}
              maxValue={progress.total}
              width="w-[180px]"
              height="h-1"
              bgColor="bg-gray-200"
              fillColor="bg-info"
            />
            <span className="text-sm font-medium text-gray-700 min-w-[25px]">
              {progress.percentage}%
            </span>
            <span className="text-sm text-gray-500 min-w-[45px]">
              {progress.filled} of {progress.total} fields filled
            </span>
          </div>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      columnMenu: false,
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit_square"
          color="black"
          size="sm"
          onClick={() => handleEdit(row)}
        />
      ),
    },
  ];

  const rows = documents.map((doc) => ({
    ...doc,
    progressData: calculateProgress(doc),
  }));

  const mappedRows = mapTableRows(rows, columns);

  const handleEdit = async (doc) => {
    try {
      setLoading(true);
      const checklistProps = doc?.id || {};
      const checklistPropValues = doc?.fields || {};
      const checklistPropFields = doc?.id?.fields || {};
      const presignedUrl = await getPresignedUrl(checklistProps.file);
      const response = await fetch(presignedUrl);
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();
      const mappedFields = fieldsToDroppedFieldsMapper(
        checklistPropValues,
        checklistPropFields,
      );
      setSelectedDocument({
        droppedFields: mappedFields || {},
        arrayBuffer: arrayBuffer,
        currentChecklist: doc,
        ...checklistProps,
      });
      setCurrentPage(1);
      setHasUnsavedChanges(false);
    } catch (error) {
      console.error("Error loading document:", error);
      showToast("Failed to load document", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateField = (fieldId, value) => {
    setSelectedDocument((prev) => {
      if (!prev) return prev;

      const updatedFields = { ...prev.droppedFields };
      //for signature store value and fontfamily seperately
      Object.keys(updatedFields).forEach((page) => {
        updatedFields[page] = updatedFields[page].map((field) => {
          if (field.id !== fieldId) return field;
          if (typeof value === "object" && value.fontFamily !== undefined) {
            return {
              ...field,
              value: value.text,
              fontFamily: value.fontFamily,
            };
          }
          //for other fields store value directly
          return {
            ...field,
            value,
          };
        });
      });

      return {
        ...prev,
        droppedFields: updatedFields,
      };
    });
    setHasUnsavedChanges(true);
  };

  const handleClose = () => {
    if (hasUnsavedChanges) {
      setHasUnsavedChanges(false);
    }
    setSelectedDocument(null);
    setCurrentPage(1);
  };

  const getAllApplicantFields = () => {
    if (!selectedDocument) return [];
    const allFields = [];
    Object.keys(selectedDocument.droppedFields || {}).forEach((page) => {
      const pageFields = selectedDocument.droppedFields[page] || [];
      const applicantFields = pageFields.filter((f) => f.role === "applicant");
      applicantFields.forEach((field) => {
        allFields.push({ ...field });
      });
    });
    return allFields;
  };

  const areAllDocumentsComplete = () => {
    return documents.every((doc) => {
      const progress = calculateProgress(doc);
      return progress.percentage === 100;
    });
  };

  const isFieldFilled = (field) => {
    if (typeof field.value === "object" && field.value?.type === "userFilled") {
      const userValue = field.value.data?.[currentUserId]?.value;
      return userValue && String(userValue).trim() !== "";
    }
    return field.value && String(field.value).trim() !== "";
  };
  const buildUpdatePayload = (fields, status) => [
    {
      type: "SET",
      value: {
        "checklists.0.documents.$[elem]": {
          fields,
          ...(status && { status }),
        },
      },
    },
  ];

  const handleSubmitDocument = async (status) => {
    try {
      setLoading(true);
      const fields = await Promise.all(
        Object.entries(selectedDocument?.droppedFields || {}).flatMap(
          ([key, list]) =>
            list?.map(async (item) => {
              try {
                let value = item?.value;
                if (item.type === "image" && typeof value !== "string") {
                  const uint8Array = new Uint8Array(value);
                  const blob = new Blob([uint8Array]);
                  const file = new File([blob], `${item.id}.png`, { type: "image/*" });
                  const uploadRes = await uploadFiles({
                    uploadType: "single",
                    field: "doc",
                    uiid: selectedDocument?.uiid,
                    entity: "onboardings",
                    category: "checklist_image",
                    coll: "Onboarding",
                    doc: file,
                  });
                  const uploadedImageUrl = uploadRes?.data?.data?.url;
                  if (!uploadedImageUrl) {
                    throw new Error("Failed to upload image");
                  }
                  value = uploadedImageUrl;
                }

                return {
                  id: item.id,
                  value,
                  type: item.type,
                };
              } catch (error) {
                console.error("Error uploading image:", error);
                throw error;
              }
            }) || [],
        ),
      );
      const payload = buildUpdatePayload(fields, status);
      console.log({ fields, selectedDocument });
      // throw new Error("Error saving document");
      if (!selectedDocument?.currentChecklist?._id || !selectedDocument?.uiid) {
        throw new Error("Invalid document data");
      }
      const response = await updateOnboarding({
        coll: "Onboarding",
        uiid: selectedDocument?.uiid,
        payload,
        patchId: selectedDocument?.currentChecklist?._id,
      });
      if (!response?.success) throw new Error("Failed to save document");
      showToast("Document saved successfully", "success");
      setHasUnsavedChanges(false);
      setSelectedDocument(null);
      await fetchOnboardingInfo();
    } catch (error) {
      console.error("Error saving document:", error);
      showToast("Failed to save document", "error");
    } finally {
      setLoading(false);
    }
  };

  const ProgressSidebar = ({ document, currentPage }) => {
    const [selectedFieldId, setSelectedFieldId] = useState("");
    const allFields = getAllApplicantFields();
    const progress = calculateProgress(document);

    const handleFieldSelect = (fieldId, isDisabled) => {
      if (isDisabled) return;
      setSelectedFieldId(fieldId);
      const field = allFields.find((f) => f.id === fieldId);
      if (field && field.page !== currentPage) {
        setCurrentPage(field.page);
      }
    };

    return (
      <div className="w-80 bg-white border-l border-l-gray-300 flex flex-col flex-shrink-0">
        <div className="p-4 border-b border-b-gray-300">
          <h3 className="text-lg font-semibold text-gray-900">Progress</h3>
        </div>

        <div className="p-4 space-y-4 overflow-y-auto flex-1">
          {/* Overall Progress */}
          <div className="bg-info-50 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">
                Overall Completion
              </span>
              <span className="text-2xl font-bold text-info-600">
                {progress.percentage}%
              </span>
            </div>
            <div className="bg-info-200 rounded-full h-3 mb-2">
              <div
                className="bg-info-600 h-3 rounded-full transition-all"
                style={{ width: `${progress.percentage}%` }}
              />
            </div>

            <div className="text-center text-sm text-gray-600 my-1">
              {progress.filled} of {progress.total} fields completed
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              Document Fields to be filled
            </h4>
            <div className="border border-gray-300 rounded-md bg-white max-h-[300px] overflow-y-auto">
              {allFields.map((field) => {
                const filled = isFieldFilled(field);
                const isSelected = selectedFieldId === field.id;

                return (
                  <div
                    key={field.id}
                    className={`px-3 py-2 text-sm cursor-pointer transition-colors ${
                      filled
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-gray-900 hover:bg-gray-100"
                    } ${isSelected && !filled ? "bg-info-50" : ""}`}
                    onClick={() => handleFieldSelect(field.id, filled)}
                  >
                    {`${filled ? "✓" : "○"} ${field.label}${
                      field.required ? " *" : ""
                    } (Page ${field.page})`}
                  </div>
                );
              })}
            </div>
          </div>
          {/* <div>
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              Field Status
            </h4>
            <div className="space-y-2 max-h-96 overflow-y-auto">
              {currentPageFields.map((field) => {
                const filled = isFieldFilled(field);
                return (
                  <div
                    key={field.id}
                    className="flex items-center gap-2 p-2 rounded hover:bg-gray-50 cursor-pointer"
                    onClick={() => handleFieldSelect(field.id)}
                  >
                    <span
                      className={`material-symbols-outlined text-lg flex-shrink-0 ${
                        filled ? "text-green-500" : "text-gray-300"
                      }`}
                    >
                      {filled ? "check_circle" : "radio_button_unchecked"}
                    </span>
                    <span
                      className={`text-sm ${
                        filled ? "text-gray-500 line-through" : "text-gray-900"
                      }`}
                    >
                      {field.label}
                      {field.required && (
                        <span className="text-red-500 ml-1">*</span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div> */}

          {progress.filled < progress.total && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
              <div className="flex items-start gap-2">
                <span className="material-symbols-outlined text-yellow-600 text-lg">
                  warning
                </span>
                <p className="text-sm text-yellow-800">
                  {progress.total - progress.filled} field(s) remaining
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  if (!onboardingInfo) {
    return (
      <div className="flex justify-center items-center h-screen">
        <NoData
          title="Unauthorized or Broken Link!"
          desc="Please Contact Support"
        />
      </div>
    );
  }

  return (
    <div className={`theme-default h-screen flex overflow-clip`}>
      {/* <div
        className="w-20
        transition-all duration-500 flex-shrink-0"
      >
        <div className="bg-[#101A26] rounded-r-xl h-screen">
          <div className="py-8 px-6 flex justify-center items-center">
            <img
              src={navHeaderLogoIcon}
              alt="Logo"
              className="transition-all duration-700 h-8 opacity-100 scale-100"
            />
          </div>
        </div>
      </div> */}

      <div
        className="flex-1 transition-all duration-500 flex flex-col overflow-hidden"
        style={{
          width: "calc(100% - 80px)",
        }}
      >
        <div className="sticky top-0 z-50 bg-white border-b shadow-sm">
          <div className="flex items-center justify-center py-4 px-5">
            <img
              src={headerLogo}
              alt="Company Logo"
              className="h-10 object-contain"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
          </div>
        </div>
        <div className="ml-2 pr-2 py-2 flex flex-1 flex-col overflow-auto">
          <div className="flex flex-col items-start gap-3 px-5 pt-5">
            <PageTitle
              title={`Welcome, ${onboardingData?.entity?.type === 1 ? `${onboardingData?.entity?.id?.firstName || ""} ${onboardingData?.entity?.id?.lastName || ""}` : onboardingData?.entity?.id?.businessName}`}
            />
            <p className="text-sm text-gray-600">
              Please complete the following onboarding forms to proceed.
            </p>
          </div>
          <div className="flex flex-col flex-1 p-5 gap-6">
            <TableAdv
              columns={columns}
              rows={mappedRows}
              limit={100}
              // hideToolBar
              // toolbarRight={{
              //   search: false,
              //   filter: false,
              //   download: false,
              //   add: [
              //     {
              //       component: (
              //         <div className="flex gap-3">
              //           <div className="flex justify-end items-end">
              //             <Button
              //               icon={"refresh"}
              //               size="sm"

              //               onClick={fetchOnboardingInfo}
              //             />
              //           </div>
              //         </div>
              //       ),
              //     },
              //   ],
              // }}
              toolbarRight={{
                search: false,
                filter: false,
                download: false,
                add: [
                  {
                    component: (
                      <div className="flex gap-3">
                        <div className="flex justify-end items-end">
                          <Button
                            icon={"refresh"}
                            variant={"outlined"}
                            title={"Refresh"}
                            size="sm"
                            onClick={fetchOnboardingInfo}
                          />
                        </div>
                      </div>
                    ),
                  },
                ],
              }}
            />

            {/* {uploadedFiles.length > 0 && (
              <div className="bg-white rounded-lg border border-gray-300 shadow-sm">
                <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="bg-blue-500 rounded-lg p-2.5">
                        <span className="material-symbols-outlined text-white text-xl">
                          folder_open
                        </span>
                      </div>
                      <div>
                        <h3 className="text-base font-semibold text-gray-900">
                          Additional Documents
                        </h3>
                        <p className="text-xs text-gray-500 mt-0.5">
                          {uploadedFiles.length} file
                          {uploadedFiles.length !== 1 ? "s" : ""} uploaded
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {uploadedFiles.map((uploadedFile) => (
                      <div
                        key={uploadedFile.id}
                        className="bg-gray-50 rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
                      >
                        <div className="p-4">
                          <div className="flex items-start gap-3">
                            <div className="flex-shrink-0">
                              <span
                                className={`material-symbols-outlined text-4xl text-info-500`}
                              >
                                {getFileIcon(uploadedFile.type)}
                              </span>
                            </div>
                            <div className="flex-1 min-w-0">
                              <div
                                className="font-medium text-gray-900 text-sm mb-1 truncate"
                                title={uploadedFile.name}
                              >
                                {uploadedFile.name}
                              </div>
                              <div className="text-xs text-gray-500 mb-2">
                                {uploadedFile.size}
                              </div>
                              <div className="flex items-center gap-1.5 text-xs text-gray-400">
                                <span className="material-symbols-outlined text-sm">
                                  schedule
                                </span>
                                <span>
                                  {uploadedFile.uploadDate} •{" "}
                                  {uploadedFile.uploadTime}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="px-4 pb-4 flex items-center justify-end gap-2">
                          <button
                            onClick={() => {
                              const url = URL.createObjectURL(
                                uploadedFile.file
                              );
                              const a = document.createElement("a");
                              a.href = url;
                              a.download = uploadedFile.name;
                              a.click();
                              URL.revokeObjectURL(url);
                            }}
                            className="text-blue-600 hover:text-blue-700 p-1 rounded"
                            title="Download"
                          >
                            <span className="material-symbols-outlined text-xl">
                              download
                            </span>
                          </button>
                          <button
                            onClick={() => handleDeleteFile(uploadedFile.id)}
                            className="text-red-600 hover:text-red-700 p-1 rounded"
                            title="Delete"
                          >
                            <span className="material-symbols-outlined text-xl">
                              delete
                            </span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )} */}

            {/* <div className="flex justify-end items-center pt-4 gap-3">
              {!areAllDocumentsComplete() && (
                <div className="flex items-center gap-2 text-sm text-yellow-700 bg-yellow-50 px-4 py-1 rounded-lg border border-yellow-200">
                  <span className="material-symbols-outlined !text-sm">
                    info
                  </span>
                  <span>Complete all documents to submit</span>
                </div>
              )}
              <Button
                title={"Submit"}
                size="sm"
                disabled={!areAllDocumentsComplete()}
              />
            </div>*/}
          </div>

          {selectedDocument && (
            <div className="fixed inset-0 z-55 bg-white flex flex-col overflow-auto animate-fadeIn">
              <div className="flex-1 flex flex-col">
                <div className="flex flex-col gap-4 bg-[#F9F9F9] py-3 mb-5">
                  <div className="rounded-lg px-6 pt-2">
                    <div className="flex items-center justify-between">
                      <div className="flex gap-3">
                        <Button
                          icon="picture_as_pdf"
                          variant="text"
                          size="xl"
                          color="black"
                          className="!px-2"
                        />
                        <div>
                          <div className="font-medium text-lg">
                            {selectedDocument.documentName}
                          </div>
                          <div className="text-sm text-gray-600 mt-1">
                            <span className="text-neutrals-400">
                              Fill your information
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center justify-center gap-3">
                        <Button
                          title={
                            isSidebarOpen ? "Hide Progress" : "Show Progress"
                          }
                          icon={isSidebarOpen ? "chevron_right" : "menu_open"}
                          variant="outlined"
                          className="!py-1 !px-4"
                          onClick={toggleSidebar}
                        />
                        <Button
                          title="Cancel"
                          variant="outlined"
                          className="!py-1 !px-4"
                          onClick={handleClose}
                        />
                        <Button
                          title="Save as Draft"
                          variant="contained"
                          className="!py-1 !px-4"
                          onClick={() => handleSubmitDocument(2)}
                          disabled={!hasUnsavedChanges}
                        />
                        <Button
                          title={"Submit"}
                          onClick={() => handleSubmitDocument(2)}
                          size="sm"
                          disabled={
                            calculateProgress(selectedDocument).percentage !==
                            100
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-1 overflow-hidden flex">
                  <div className="flex-1 overflow-hidden flex relative">
                    <DocumentPreview
                      document={selectedDocument}
                      mode="applicant"
                      userId={currentUserId}
                      userRole="applicant"
                      onUpdateField={handleUpdateField}
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                    />

                    <div
                      className={`transition-all duration-300 ease-in-out ${
                        isSidebarOpen ? "w-80 opacity-100" : "w-0 opacity-0"
                      } overflow-hidden`}
                    >
                      {isSidebarOpen && (
                        <ProgressSidebar
                          document={selectedDocument}
                          currentPage={currentPage}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <Backdrop isOpen={loading}>
            <LogoLoader />
          </Backdrop>
        </div>
      </div>
    </div>
  );
};

export default ApplicantFill;
